import type { LayoutLoad } from './$types';
import { redirect } from '@sveltejs/kit';

export const load = (async ({ parent, params, url }) => {
	if (url.pathname.includes('/ticketboerse/login')) {
		return;
	}

	const { session } = await parent();
	if (!session) {
		throw redirect(303, `/${params.locale}/ticketboerse/login?redirect_uri=${url.pathname}`);
	}

	return {
		session: session
	};
}) satisfies LayoutLoad;
